// extracted by mini-css-extract-plugin
export default {"ckEditor":"addForm_ckEditor__Y4ux+","ck-content":"addForm_ck-content__yyebR"};